import PropTypes from "prop-types";
import React from "react";
import RCPagination from "rc-pagination";
import enUsLocale from "rc-pagination/lib/locale/en_US";
import { appendClassName } from "../../../../helpers/view-helpers";
import { useTranslation } from "react-i18next";

function RcPagination({
  className,
  current,
  resultsPerPage,
  onChange,
  totalPages,
  ...rest
}) {
  const { t } = useTranslation();
  const textItemRender = (current, type, element) => {
    if (type === "prev") {
      return t("prev");
    }
    if (type === "next") {
      return t("next");
    }
    if (type === "jump-prev") {
      return;
    }
    if (type === "jump-next") {
      return;
    }
    return element;
  };
  return (
    <RCPagination
      current={current}
      onChange={onChange}
      pageSize={resultsPerPage}
      total={totalPages * resultsPerPage}
      className={appendClassName(["c-pager", "sui-paging"], className)}
      locale={enUsLocale}
      itemRender={textItemRender}
      {...rest}
    />
  );
}

RcPagination.propTypes = {
  current: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  resultsPerPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  className: PropTypes.string,
};

export default RcPagination;
